import { render, staticRenderFns } from "./DisqualifierList.vue?vue&type=template&id=226751b4"
import script from "./DisqualifierList.vue?vue&type=script&lang=js"
export * from "./DisqualifierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports